import script from "./toolsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./toolsList.vue?vue&type=script&lang=ts&setup=true"

import "./toolsList.vue?vue&type=style&index=0&id=3de6eb22&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3de6eb22"]])

export default __exports__